export default __webpack_public_path__ + "static/media/rescue-bonus-ico.3a78c155.svg";